import { useEffect, useState } from 'preact/hooks';
import type { GameState } from '../engine/state';
import { getState, subscribe } from '../engine/store';

/** Redessine le composant à chaque changement de l'état du jeu. */
export function useGame(): GameState {
  const [, setVersion] = useState(0);
  useEffect(() => subscribe(() => setVersion((version) => version + 1)), []);
  return getState();
}

/** Le mode développeur s'active en ajoutant ?dev à l'adresse. */
export const DEV_MODE =
  typeof location !== 'undefined' && new URLSearchParams(location.search).has('dev');
